import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { NavItem, NavLink, Nav } from "reactstrap";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div id="Footer">
        <div className="FooterContents">
          <div className="FooterLogo" />
          <div className="FooterTxt">
            <div className="FooterLink">
              <Nav>
                <NavItem>
                  <NavLink to="/" tag={Link}>
                    {t('HOME')} <span className="breakPoint">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/login" tag={Link}>
                    {t('Login')} <span className="breakPoint">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/register" tag={Link}>
                    {t('Sign Up')} <span className="breakPoint">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/Privacy" tag={Link} target="_blank">
                    {t('Privacy Policy')} <span className="breakPoint">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink to="/Prohibited" tag={Link}>
                    {t('Email Collection Refusal')}
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <div className="DividedLine" />
            <div className="FooterCominfo">
              {t('Address')} : {t('Address Value')}<br/>
              {t('CEO')} : {t('CEO Value')}<br/>
              {t('Phone')} : {t('Phone Value')}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{t('Email')} : {t('Email Value')}
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="CopyrightTxt">
            Copyright © 2023 Intospace All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}